import React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

const logo = 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop,q=95/YlevgP5nreivo46l/wibbes_icon-trans-dOqygjJqpqUl9v39.png';
const link = 'https://vibbes.tv';

const useStyles = makeStyles({
  appBar: {
    background: '#538181', // Test - couleur de fond rouge
  },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  toolbar: {
    maxHeight: 72,
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    maxHeight: '72px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    marginRight: 16,
  },
  link: {
    color: '#FFF',
    marginRight: 10,
    fontSize: 14,
  }
});

const CustomAppBar = (props) => {
  const classes = useStyles();
  return (
    <AppBar {...props} color="secondary" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <img src={logo} alt="logo" className={classes.logo} />
      </Toolbar>
      <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title" />
      <a className={classes.link} href={link} target="_blank" rel="noopener noreferrer">Go Back to Vibbes.tv</a>
    </AppBar>
  );
};

export default CustomAppBar;
